<template>
  <div class="p-6">
    <h2 class="text-2xl font-semibold mb-6">My Images</h2>

    <div v-if="imageStore.images.length > 0">
      <div class="mb-4">
        <FilterInput v-model="searchQuery" placeholder="Search images..." />
      </div>

      <div v-if="bubblesStore.loading" class="text-center py-8">
        <p class="text-gray-600">Loading images...</p>
      </div>
      <div v-else-if="bubblesStore.error" class="text-center py-8 text-red-500">
        <p>{{ bubblesStore.error }}</p>
      </div>
      <div v-else class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
        <AppLink
          v-for="image in imageStore.filteredImages"
          :key="image.uuid"
          :to="`/bubble/${image.uuid}`"
        >
          <div class="aspect-square cursor-pointer">
            <NuxtImg
              v-if="getImageSrc(image)"
              :src="getImageSrc(image)"
              :alt="image.filename"
              class="w-full h-full object-cover rounded-lg"
              :modifiers="{ fit: 'cover', width: 300, height: 300 }"
            />
            <div
              v-else
              class="w-full h-full bg-gray-200 rounded-lg flex items-center justify-center"
            >
              <span class="text-gray-500">No Image</span>
            </div>
          </div>
        </AppLink>
      </div>
    </div>
    <div v-else class="text-center py-8">
      <p class="text-gray-600 mb-4">You don't have any images yet.</p>
      <Button @click="navigateToAddImage"> Add Your First Image </Button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useBubblesStore } from '@/stores/bubbles'
import { useImageStore } from '@/stores/core/imageStore'
import FilterInput from '@/components/bubbles/view/helpers/FilterInput.vue'
import { useRouter } from 'vue-router'
import type { ImageBubble } from '@/stores/interfaces'
import { Button } from '@/components/ui/button'
import AppLink from '@/components/ui/link/AppLink.vue'

const router = useRouter()
const bubblesStore = useBubblesStore()
const imageStore = useImageStore()

const searchQuery = computed({
  get: () => imageStore.searchQuery,
  set: (value) => imageStore.setSearchQuery(value),
})

onMounted(async () => {
  imageStore.setSearchQuery('')

  if (!bubblesStore.bubbleTypes['image']) {
    await bubblesStore.fetchBubbleTypes()
  }
  if (!bubblesStore.bubblesByType['image'] || bubblesStore.bubblesByType['image'].length < 5) {
    await bubblesStore.fetchBubblesByType('image')
  }
  imageStore.images = (bubblesStore.bubblesByType['image'] as ImageBubble[]) || []
})

function navigateToAddImage() {
  router.push('/dashboard/add')
}

function getImageSrc(image: ImageBubble) {
  if (image.filePath) {
    return `${image.filePath}`
  }
  return undefined
}
</script>
